<script setup>
import { GA } from '@/mixins/Ga';
import { setUri } from '@/mixins/Commons.js';

const props = defineProps({
    products: {
        type: Array,
        default: () => [],
    },
    titleTop: { type: String, default: '' },
    cta: { type: String, default: '' },
    ctaLink: {
        type: [String, Object],
        default: '',
    },
    bgClass: { type: String, default: 'bg-light-blue' },
    btnClass: { type: String, default: 'bg-dark-blue text-white' },
    color: { type: String, default: '' },
});

const ga = new GA({ category: 'endBody', action: 'clicInterne' });
const parsedLink = setUri({
    uri: props.ctaLink,
});
</script>
<template>
    <div
        v-if="products && products.length"
        class="ProductCta pb-0 pt-4 xl:py-12"
        :class="bgClass"
    >
        <div
            v-if="xs || products.length > 1"
            class="ProductCta__top relative mx-6 mb-5 flex flex-col items-start justify-between md:mb-12 md:flex-row md:items-end xl:mx-20 xl:mb-18"
        >
            <h2 class="ProductCta__top-title h3 text-balance">
                {{ titleTop }}
            </h2>
        </div>
        <div class="ProductCta__container ProductCta__blocks relative mx-6 flex flex-col flex-wrap justify-between md:flex-row xl:mx-20">
            <div class="Products__blocks grid w-full grid-cols-1 justify-between gap-6 md:grid md:grid-cols-3 xl:gap-12">
                <div
                    v-if="products.length == 1 && (xl || md)"
                    class="ProductCta__text relative mb-12 flex flex-col self-center"
                >
                    <h2 class="ProductCta__top-title h3">
                        {{ titleTop }}
                    </h2>
                    <router-link
                        :to="{ name: 'products.' + lang }"
                        v-on:click="ga.send({ label: 'voirTousProduits' })"
                    >
                        <Btn
                            class="ProductCta__cta"
                            color="currentColor"
                            :text="cta"
                            size="small"
                        />
                    </router-link>
                </div>
                <router-link
                    v-for="product in products"
                    :key="product.id"
                    :to="setUri({ uri: product.uri })"
                    class="Products__block group relative flex h-64 min-h-[60vw] flex-col items-center justify-start overflow-hidden rounded-2xl bg-white px-6 py-8 text-left md:h-54 md:min-h-0 md:p-0 md:pt-2.5 md:text-center xl:h-54"
                    v-on:click="ga.send({ label: product.title })"
                >
                    <div
                        class="aspect-square absolute bottom-0 h-[60vw] w-[60vw] translate-y-1/2 rounded-[100%] bg-bright-blue transition-all duration-500 md:h-[18vw] md:w-[18vw] can-hover:group-hover:h-[150%] can-hover:group-hover:w-[150%] can-hover:group-hover:translate-y-0 can-hover:group-hover:rounded-none"
                    />
                    <div class="absolute bottom-3 h-[65%] max-h-[45%] w-[50%] xl:max-h-[65%]">
                        <img
                            ref="image"
                            class="absolute bottom-0 left-0 h-full w-full object-contain object-bottom"
                            :src="product.cover[0].url"
                            :alt="product.cover[0].title"
                            :width="product.cover[0].width"
                            :height="product.cover[0].height"
                        />
                    </div>
                    <h3 class="Products__title relative mt-2 text-2xl font-medium leading-none transition-all duration-500 md:mx-12 md:mb-6 xl:text-xl">
                        {{ product.title }}
                    </h3>
                    <!--<div
                        class="Products__arrow text-dark-blue can-hover:group-hover:md:opacity-100 w-4 opacity-100 transition duration-500 md:absolute md:bottom-4 md:right-4 md:w-12 md:text-white md:opacity-0"
                    >
                        <Icon svgclass="fill-current" type="arrow" />
                    </div>-->
                </router-link>
            </div>
            <div
                v-if="parsedLink"
                class="mt-10 flex w-full justify-center"
            >
                <div class="ProductCta__bottom relative z-10 flex justify-center pb-16 text-center">
                    <a
                        v-if="parsedLink && typeof parsedLink == 'string' && parsedLink.startsWith('http')"
                        class="block whitespace-nowrap"
                        :href="parsedLink"
                        :target="ctaTarget"
                    >
                        <Btn
                            :text="cta"
                            size="small"
                            class="w-full text-white"
                            :class="['bg-dark-' + color]"
                        />
                    </a>
                    <router-link
                        v-else
                        class="whitespace-nowrap"
                        :to="parsedLink"
                        :target="ctaTarget"
                        v-on:click="ga.send({ label: gaLabel })"
                    >
                        <Btn
                            :text="cta"
                            size="small"
                            class="w-full text-white"
                            :class="['bg-dark-' + color]"
                        />
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
